import TextInformation from "./TextInformation";
import Form from "./Form";

const Formulario = () => {
  return (
    <div className="flex w-full bg-dark-gray flex-col md:flex-row">
      {/* Text Section */}
      <div className="w-full md:w-1/2">
        <TextInformation />
      </div>

      {/* Form Section */}
      <div className="w-full md:w-1/2 p-4 md:p-10 md:p-0">
        <Form />
      </div>
    </div>
  );
};

export default Formulario;
